import { render } from "./announcment.vue?vue&type=template&id=fdd89ff8&scoped=true"
import script from "./announcment.vue?vue&type=script&lang=js"
export * from "./announcment.vue?vue&type=script&lang=js"

import "./announcment.vue?vue&type=style&index=0&id=fdd89ff8&scoped=true&lang=css"

import exportComponent from "/home/forge/clients.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd89ff8"]])

export default __exports__